import {
  ACCOUNT_EXISTS_MESSAGE,
  GENERIC_ERROR_MESSAGE,
  GENERIC_ERROR_TITLE,
  INFO_TITLE,
  LOGIN_INVALID_CREDENTIALS_MESSAGE,
  REGISTER_SUCCESS_MESSAGE,
  REGISTER_SUCCESS_TITLE,
  SERVER_ERROR_MESSAGE,
  SERVER_ERROR_TITLE,
} from "@/constants/messages";

export const TOAST_MESSAGES = {
  GENERIC_ERROR: {
    title: GENERIC_ERROR_TITLE,
    description: GENERIC_ERROR_MESSAGE,
  },
  SUCCESS: {
    title: REGISTER_SUCCESS_TITLE,
    description: REGISTER_SUCCESS_MESSAGE,
  },
  SERVER_ERROR: {
    title: SERVER_ERROR_TITLE,
    description: SERVER_ERROR_MESSAGE,
  },
  INVALID_CREDENTIALS: {
    title: GENERIC_ERROR_TITLE,
    description: LOGIN_INVALID_CREDENTIALS_MESSAGE,
  },
  ACCOUNT_EXISTS: {
    title: INFO_TITLE,
    description: ACCOUNT_EXISTS_MESSAGE,
  },
};
